/**
 * @file Contains the hook for determining the visibility of the feed navigation
 */
import useComposeType from '../../../../../../hooks/router/search/useComposeType';
import useIsComposeOpen from '../../../../../../hooks/router/search/useIsComposeOpen';

/**
 * Hook for determining the visibility of the feed navigation
 *
 * @returns Parameters for showing the draft and navigation
 */
const useFeedNavigation = () => {
  const isComposeOpen = useIsComposeOpen();
  const composeType = useComposeType();
  const isComposeMinimized = composeType !== null && !isComposeOpen;

  const shouldShowDraft = isComposeMinimized;
  const shouldShowNavigation = !isComposeOpen;

  return {
    shouldShowDraft,
    shouldShowNavigation,
  };
};

export default useFeedNavigation;
